// source: template-project@7007a338a apps/backoffice/src/pages/onboarding-v2/Transcript.tsx (JUNO, SCOUT: names, roles)
/**
 * The onboarding's two chat agents. Presentation only: no LLM is behind them in Phase 1, every line they
 * say is a static template. Names and roles are TP's; the orb looks come from `ui/agent-orb` (hashed from the id, as in TP).
 */
export type OnboardingAgent = Readonly<{
  /** Orb id (see AgentOrb) and message-author key. */
  id: 'juno' | 'scout';
  name: string;
  role: string;
}>;

export const AGENTS = {
  juno: { id: 'juno', name: 'Juno', role: 'Growth Strategist' },
  scout: { id: 'scout', name: 'Scout', role: 'Market Researcher' },
} as const satisfies Record<string, OnboardingAgent>;
